import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormData } from "../types/prescription.types";

export const usePrescriptionForm = (initialData?: any) => {
  const methods = useForm<FormData>({
    defaultValues: {
      Case: initialData?.Case || "",
      Drugs: initialData?.Drugs || [],
    },
  });

  useEffect(() => {
    if (initialData) {
      methods.reset({
        Case: initialData.Case || "",
        Drugs: initialData.Drugs || [],
      });
    }
  }, [initialData, methods]);

  return methods;
};
